import { render, staticRenderFns } from "./ConfigArrowRightIcon.vue?vue&type=template&id=135b5f73"
import script from "./ConfigArrowRightIcon.vue?vue&type=script&lang=js"
export * from "./ConfigArrowRightIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports